import { ReactComponentElement, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BedroomCard from "./BedroomCard";
import Checkers from "../../../../../../helpers/class/Checkers";
import { SwiperSlide } from "swiper/react";
import SwipperWrapper from "../../../../properties/partials/SwipperWrapper";
import { AnyComponent } from "styled-components/native/dist/types";
import { fetchBedroomPricesAction, fetchPropertyBookingBedrooms, setDateRange, setSearchSpinner } from "../../../../../../redux/actions";
import UnderSliderContainedBar from "../../../../index/bookingSearchBar/UnderSliderContainedBar";
import SliderContainedBar from "../../../../index/bookingSearchBar/SliderContainedBar";
import BookingSearchBar from "../../../../index/BookingSearchBar";
import RightModal from "../../../../properties/partials/RightModal";
import ContentWrapper from "../../../../properties/partials/ContentWrapper";
import BedroomsContentWrapper from "../../../../properties/partials/BedroomsContentWrapper";
import BookingBedroomButtons from "./BookingBedroomButtons";
import SinglePropertyData from "./ChainPropertyData";
import Skeleton from "react-loading-skeleton";
import BedroomData from "./BedroomData";

export default function BedroomsView(props) {

  const dispatch = useDispatch()

  const bookingBedrooms = useSelector(state => state['singlePropertyData']['bookingBedrooms'])

  const checkin = useSelector(state => state['propertiesParams']['checkin'])

  const bedroomPricing = useSelector(state => state['appSettings']['bedroomPricing'])

  const triggerSearh = useSelector(state => state['appSettings']['searchTrigger'])

  const checkout = useSelector(state => state['propertiesParams']['checkout'])

  const pageId = useSelector(state => state['propertiesParams']['page_id'])

  const adults = useSelector(state => state['propertiesParams']['adults'])

  const kids = useSelector(state => state['propertiesParams']['kids'] + state['propertiesParams']['infants'])

  const propertyId = useSelector(state => state['propertiesParams']['property_id']);

  useEffect(() => {
    dispatch<any>(fetchPropertyBookingBedrooms(propertyId))
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      await dispatch<any>(fetchBedroomPricesAction(pageId, propertyId, checkin, checkout, adults, kids));
      dispatch(setSearchSpinner(false));
    };
    fetchData();
  }, [triggerSearh]);

  return (
    <>
      {bookingBedrooms && Checkers.isValidArray(bookingBedrooms) ? (
        <>
          <p className="block-title m-t-40 hint-text no-margin justify-content-left text-left d-block ">
            See all the available room types at the property
          </p>
          <h2 className="pb-4 mt-1 fw-normal">Room types</h2>

          <div className="SearchBar-Form__column row justify-content-end bg-white no-margin p-2 w-100 d-flex border-radius-10 shadow position-relative">

            <BookingSearchBar
              containerClass={"container-fluid"}
              padding={10}
              isManager={true}
              noShadow={true}
              sliderSearchBar={true}
              sliderSearchBarFullWidth={false}
              bookingSearchbarWithBedrooms={props.bookingBedrooms}
              isHomePage={false}
              isHotel={props.isHotel ? props.isHotel : false}
            />

          </div>
        </>) : (
        <div>
          <Skeleton height={75} className="col-12 b-rad-lg d-block" />
        </div>
      )}
      <div className="pt-10 mt-4">
        <div className="row">
          {bookingBedrooms && Checkers.isValidArray(bookingBedrooms) ? (
            bookingBedrooms.map((bedroom, key) => (
              <div className="col-4 col-md-4" key={key}>
                <BedroomData bedroom={bedroom} prices={bedroomPricing} />
              </div>
            ))
          ) : (
            <>
              <div>
                <Skeleton height={340} className="col-12 b-rad-lg d-block" />
                <Skeleton height={27} className="col-12 b-rad-lg d-block" />
                <Skeleton height={27} className="col-12 b-rad-lg d-block" />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
